import { Injectable } from '@angular/core';
import { Query } from 'apollo-angular';
import gql from 'graphql-tag';
import { property, propertyVariables } from './types/property';

@Injectable({ providedIn: 'root' })
export class HotelDetailGQL extends Query<property, propertyVariables> {
  document = gql`
    query property($id: Int, $code: String, $slug: String) {
      property(id: $id, code: $code, slug: $slug) {
        plans {
          id
          planName
          description
          image {
            id
            imagePath
            imageName
          }
          overrideUrl
        }
        property {
          id
          name
          title
          description
          webUrl
          slug
          metaTitle
          metaDescription
          currencyCode
          latitude
          longitude
          # googleMapId
          comingSoon
          checkinTime
          checkoutTime
          checkInEndTime
          cancellationpolicy
          street
          city
          state
          postalCode
          phoneNumber
          phoneAreacode
          faxNumber
          email
          urgentNotification
          awardText
          infoTitle
          infoDetails
          petFriendly
          serviceAnimalAllowed
          optInForDonation
          hotelCategory
          accessibilities {
            id
            name
            status
            description
          }
          handicapInstructions
          knowledges {
            id
            title
            imagePath
            status
            title
            description
          }
          extras {
           quickTextId 
          }
        }
        roomTypes {
          id
          description
          type
          maxOccupancy
          baseOccupancy
          size
          roomTypeImages {
            id
            caption
            accessCode
            imageName
            imagePath
            mediaType
          }
          bookingEngineDisplayed
          status
          sortOrder
        }
        placeOfInterests {
          id
          description
          webUrl
          name
          image {
            id
            imageName
            imagePath
          }
        }
        amenities {
          id
          name
          logo
          matIcon
        }
        customizations {
          id
          name
          image
          category
          subCategory
          type
          description
          externalUrl
        }
        images {
          id
          accessCode
          imageName
          imagePath
          caption
          amazonS3Url
        }
      }
    }
  `;
}
